import { SAVE_POPUP_VARIANT } from '../../../features/automationStudioNew/constants';

export const SAVE_EXECUTION_RECORD_VARIANT = SAVE_POPUP_VARIANT;

export const SAVE_EXECUTION_RECORD_COPY = {
    [SAVE_EXECUTION_RECORD_VARIANT.DEFAULT]: {
        modalTitle: 'Save Execution Record',
        heading: 'Link to Test Case',
        description:
            'Your AI execution results will be converted into a reusable automation script and linked to an existing test case.',
        primaryButtonLabel: 'Save',
    },
    [SAVE_EXECUTION_RECORD_VARIANT.INSTRUCTIONS_ONLY]: {
        modalTitle: 'Save Instructions',
        heading: 'Link test case to save instructions',
        description:
            'Saving will update automation instructions only. The current session plan will not be saved. The test case will be marked Not Automated. Any existing automation on the selected test case will be removed.',
        primaryButtonLabel: 'Save Instructions',
    },
};

export const SAVE_EXECUTION_RECORD_OVERWRITE_WARNING =
    'This action will overwrite the existing automation script associated with the test case.';
